var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_22399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.87499 20.274C3.96124 19.7608 4.98761 19.2733 6.01398 18.7858C9.30692 17.2291 12.6084 15.681 15.9014 14.1158C17.9028 13.1664 19.0061 11.2334 18.8522 9.00959C18.7068 6.92264 17.287 5.11793 15.2428 4.485C13.746 4.02314 12.3347 4.33105 10.9491 5.00674C7.97264 6.45222 4.97905 7.83782 1.98547 9.24908C1.32688 9.55699 0.779483 9.4287 0.300509 8.8813C-0.058721 8.47075 -0.11004 7.85493 0.223531 7.38451C0.38604 7.16212 0.616974 6.9654 0.865014 6.84566C5.25275 4.7587 9.6405 2.68885 14.0368 0.627556C14.2079 0.542025 14.4217 0.516366 14.6184 0.516366C16.9876 0.507812 19.3483 0.516366 21.7175 0.507812C22.0339 0.507812 22.1451 0.601897 22.1451 0.918361C22.1451 2.64609 22.1622 4.36526 22.1622 6.09299C22.1622 8.71879 22.0853 11.3446 22.1793 13.9618C22.3504 18.8286 18.7667 22.6261 15.0546 23.9005C10.7524 25.3888 6.04819 24.0887 3.13159 20.6076C3.04605 20.5221 2.98618 20.428 2.87499 20.274Z",
    fill: "#C9194A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05119 16.8441C0.666301 15.7151 0.546557 14.6374 0.55511 13.534C0.55511 13.44 0.734725 13.2518 0.811703 13.2603C2.42824 13.4485 3.76252 12.6702 5.13957 12.0201C7.76537 10.7799 10.3912 9.53974 13.0084 8.29954C13.5045 8.06006 13.992 8.01729 14.4625 8.35942C14.8816 8.67588 15.0697 9.10353 15.0013 9.62527C14.9329 10.1385 14.6164 10.4635 14.1631 10.6773C12.6663 11.3787 11.1781 12.0886 9.68127 12.7899C9.14242 13.038 8.58647 13.2518 8.04763 13.5084C5.92646 14.5262 3.80529 15.5526 1.67557 16.5789C1.4874 16.6645 1.29068 16.7415 1.05119 16.8441Z",
    fill: "#C9194A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95258 0.653215C3.54132 1.32036 2.12151 1.9875 0.607607 2.70596C0.607607 1.97895 0.599054 1.34602 0.61616 0.713087C0.61616 0.644662 0.761563 0.524919 0.829988 0.516366C2.18993 0.507812 3.54987 0.507812 4.90982 0.507812C4.92692 0.559131 4.93548 0.601897 4.95258 0.653215Z",
    fill: "#C9194A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_22399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1696,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportsLogo);
export default __webpack_public_path__ + "static/media/supports-logo.e3c9661740c7083d05b9d90635f74b35.svg";
export { ForwardRef as ReactComponent };